export default __webpack_public_path__ + "static/media/mobile_04.9a80db43.png";